module.exports = __webpack_public_path__ + "static/media/donate.58630a15.jpg";